export const createGroupStructure = (groupData, parsedSettings, tarifas) => {
  const p = groupData[0]; // primer pasajero del grupo
  const tipoMovil = p.TipoMovil?.toUpperCase() || "DESCONOCIDO";

  // Buscar tarifa exacta por tipo_movil
  const tarifa = tarifas.find((t) => t.tipo_movil === tipoMovil);

  // Si no hay tarifa encontrada, retornamos mensaje de error
  if (!tarifa) {
    return {
      error: "sin tarifas - vehículo no encontrado",
      grupo: p.Grupo,
      tipo_movil: tipoMovil,
      pasajero: p.Pasajero,
    };
  }

  // Usamos las tarifas obtenidas (ya no usamos valores por defecto)
  const capabilityValue = tipoMovil === "VAN" ? 6 : 1;
  const tagRate = Number(tarifa.tag_rate);
  const minRate = Number(tarifa.min_rate);
  const kmRate = Number(tarifa.km_rate);
  const BBandera = Number(tarifa.bandera);

  const KM = Number(p.KMRecorrido) || 0;
  const Min = Number(p.MinRecorrido) || 0;
  const TAGCantidad = Number(p.CantTAG) || 0;
  const TotalPeaje = Number(p.TotalPeaje) || 0;
  const Estacionamiento = Number(p.TotalEstacionamineto) || 0;

  const TAG = TAGCantidad * tagRate;
  const PECosto = TotalPeaje + Estacionamiento;
  const MinExtra = Min * minRate;
  const KMCosto = KM * kmRate;
  const TotalServicio = TAG + PECosto + MinExtra + KMCosto + BBandera;

  const structure = {
    bookingType: "ASAP",
    passengers: 1,
    //+++=========================================+++
    // ++==Inicio Datos de Prueba DEMODIGITAL ==++
    // customerId: 144,
    // customerDisplayName: "Demo (Digital)",
    // accountCode: "0001",
    // ++== FIN Datos de Prueba DEMODIGITAL ==++
    //+++=========================================+++
    customerId: 64,
    customerDisplayName: "BANCO DE CHILE",
    accountCode: "171",
    hasSpecialAccount: false,
    paymentMethod: "Cash",
    paymentType: "Account",
    bookingSource: "Operator",
    capabilities: [capabilityValue],
    source: "Completed",
    // DATOS DINAMICOS
    companyId: parsedSettings.companyId,
    name: p.Pasajero.toUpperCase(),
    pickupDueTime: `${p.Fecha}T${p.HoraInicio}:00-04:00`,
    ourReference: p.TipoVale.toUpperCase(),
    officeNote: `${p.ValeFisico}`,
    distance: p.KMRecorrido,
    yourReferences: {
      yourReference2: `${p.RutId}`,
      yourReference5: p.Pasajero.toUpperCase(),
      yourReference6: `${p.CentroCosto}`,
    },
    price: TotalServicio,
    pricing: {
      // Precio Final de Calculos
      cost: TotalServicio,
      price: TotalServicio,
      // Monto por Peaje o Estacionamiento
      gratuityAmount: PECosto,
      // Valores por TAG
      extraCost: TAG,
      // Valores por Tiempo
      waitingTime: p.MinRecorrido,
      waitingTimeCost: MinExtra, //Valor final del calculo tiempo
      waitingTimePrice: MinExtra, //Valor final del calculo tiempo
    },
    flight: {
      flightNumber: `${p.HoraTermino}`,
      summary: `${p.HoraTermino}`,
    },
    pickup: {
      address: {
        source: "TeleAtlas",
        text: p.origin.address.toUpperCase(),
        zoneId: p.origin.zoneId,
        coordinate: {
          latitude: p.origin.latitude,
          longitude: p.origin.longitude,
          isEmpty: false,
        },
        note: "",
        house: "",
        street: p.origin.address.toUpperCase(),
        town: "",
        postCode: "",
        bookingPriority: 0,
        priorityAppliesTo: {
          pickup: true,
          via: true,
          destination: true,
        },
      },
      note: "",
      type: "Pickup",
      completed: false,
      passengerDetailsIndex: 0,
    },
    destination: {
      address: {
        source: "TeleAtlas",
        text: p.destination.address.toUpperCase(),
        zoneId: p.destination.zoneId,
        coordinate: {
          latitude: p.destination.latitude,
          longitude: p.destination.longitude,
          isEmpty: false,
        },
        note: "",
        house: "",
        street: p.destination.address.toUpperCase(),
        town: "",
        postCode: "",
        bookingPriority: 0,
        priorityAppliesTo: {
          pickup: true,
          via: true,
          destination: true,
        },
      },
      note: "",
      type: "Destination",
      completed: false,
      passengerDetailsIndex: null,
    },

    vehicle: {
      id: p.idVehiculo,
      callsign: `${p.NMovil}`,
    },
    driver: {
      id: p.idConductor,
      callsign: `${p.NMovil}`,
      fullName: p.NameDriver.toUpperCase(),
    },
  };

  if (groupData.length > 1) {
    structure.vias = groupData.slice(1).map((pasajero, index) => ({
      address: {
        text: pasajero.origin.address?.toUpperCase() || "",
        coordinate: {
          latitude: pasajero.origin.latitude,
          longitude: pasajero.origin.longitude,
        },
        street: pasajero.origin.address?.toUpperCase() || "",
      },
      note: "",
      type: "Pickup",
    }));
  }

  return structure;
};
